export default {
    getThematics: `${process.env.REACT_APP_API}/catalogos/thematics`,
    getClasifications: `${process.env.REACT_APP_API}/catalogos/clasifications`,
    getSubCategories: `${process.env.REACT_APP_API}/catalogos/subClasifications`,
    getTags: `${process.env.REACT_APP_API}/catalogos/tags`,
    getRegions: `${process.env.REACT_APP_API}/catalogos/regions`,
    getMunicipalities: `${process.env.REACT_APP_API}/catalogos/municipios`,
    getActionsPermission: `${process.env.REACT_APP_API}/users/actionsPermission`,
    getStaffFunctions: `${process.env.REACT_APP_API}/catalogos/staffFunctions`,
    getSchoolLevels: `${process.env.REACT_APP_API}/catalogos/schoolLevels`,
    getSchoolTurns: `${process.env.REACT_APP_API}/catalogos/schoolTurns`,
    getSchoolCycles: `${process.env.REACT_APP_API}/catalogos/schoolCycles`,
    getProjects: `${process.env.REACT_APP_API}/proyects/getAll`,
    getRamales: `${process.env.REACT_APP_API}/catalogos/ramales`,
    getVrfs: `${process.env.REACT_APP_API}/catalogos/vrfs`,
    connectionPoints: `${process.env.REACT_APP_API}/connection-points`,
    getStaff: `${process.env.REACT_APP_API}/catalogos/staff`,
    getRadiobases: `${process.env.REACT_APP_API}/catalogos/radiobases`,
    getClusters: `${process.env.REACT_APP_API}/catalogos/clusters`,
    getConnectionModalities: `${process.env.REACT_APP_API}/catalogos/connection-modalities`,
    getConnectionTypes: `${process.env.REACT_APP_API}/catalogos/connectionTypes`,
    getOlts: `${process.env.REACT_APP_API}/catalogos/olts`,
    downloadList: `${process.env.REACT_APP_API}/connection-points/export`,
    tickets: `${process.env.REACT_APP_API}/tickets`,
    getModalities: `${process.env.REACT_APP_API}/catalogos/modalities`,
    getConnectionPointsChunk: `${process.env.REACT_APP_API}/connection-points/getConnectionPointsChunk`,
    createAction: `${process.env.REACT_APP_API}/connection-points/createAction`,
    getAction: `${process.env.REACT_APP_API}/connection-points/getAction`
}
